import StyleSheet from '../../utils/helpers/styleSheet'
import {useAppDispatch, useAppSelector} from '../../stores/configureStore'
import {selectToolboxTabPanel} from '../../stores/toolbox/toolbox.reducer'
import Graphics from './Graphics'
import Photo from './Photo'
import Caption from './Caption'
import PhotoUpload from './PhotoUpload'
import AddCaption from './AddCaption'
import PixaBay from './PixaBay'
import MaskedPhoto from './MaskedPhoto'
import {useEffect} from 'react'
import {Img} from '../../models/editor/img'
import {Config} from '../../constants/Config'
import {useTranslation} from 'react-i18next'

const styles: StyleSheet = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  tabPanelSwitcher: {
    display: 'flex',
    flexDirection: 'row',
  },

  tabPanelContainer: {
    position: 'relative',
    overflowY: 'auto',
    height: '100%',
  },
}

interface ToolboxProps {
  isGraphics?: boolean
  textOnly?: boolean
  color?: string
}

export default function Toolbox({
  textOnly = false,
  isGraphics = false,
  color = 'transparent',
}: ToolboxProps) {
  const {t} = useTranslation()
  const {activeTabPanel} = useAppSelector(store => store.toolbox)
  const {images, selectedImageId} = useAppSelector(store => store.editor)
  const selectedImage = images.find(
    (image: Img) => image.id === selectedImageId,
  )
  const dispatch = useAppDispatch()

  useEffect(() => {
    const selectedImg = images.find(
      (image: Img) => image.id === selectedImageId,
    )
    if (
      activeTabPanel === 'Edit' &&
      selectedImg?.type === 'masked' &&
      selectedImg.inside.length === 1 &&
      selectedImg.inside[0].url ===
        `${Config.websiteUrl}/wp-content/themes/poloforma/assets/mask_placeholder.png`
    ) {
      dispatch(
        selectToolboxTabPanel({
          tabPanel: 'PhotoUpload',
          selectForMasked: {
            id: selectedImg.id,
            insideIndex: 0,
          },
        }),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, activeTabPanel, selectedImageId])

  return (
    <div style={styles.container}>
      <div style={styles.tabPanelSwitcher}>
        {!textOnly && !isGraphics && (
          <>
            <div
              className={`switcherButton  ${
                activeTabPanel === 'Graphics' ? 'activeSwitcherButton' : ''
              }`}
              onClick={() => {
                dispatch(selectToolboxTabPanel({tabPanel: 'Graphics'}))
              }}>
              {t('Grafikák')}
            </div>
            <div
              className={`switcherButton  ${
                (activeTabPanel === 'Edit' &&
                  selectedImage?.type !== 'caption') ||
                activeTabPanel === 'PhotoUpload'
                  ? 'activeSwitcherButton'
                  : ''
              }`}
              onClick={() => {
                dispatch(selectToolboxTabPanel({tabPanel: 'PhotoUpload'}))
              }}>
              {t('Fénykép')}
            </div>
          </>
        )}
        <div
          style={textOnly ? {borderRadius: '15px 15px 0 0'} : {}}
          className={`switcherButton  ${
            activeTabPanel === 'AddCaption' ||
            (activeTabPanel === 'Edit' && selectedImage?.type === 'caption')
              ? 'activeSwitcherButton'
              : ''
          }`}
          onClick={() => {
            dispatch(selectToolboxTabPanel({tabPanel: 'AddCaption'}))
          }}>
          {t('Szöveg')}
        </div>
      </div>
      <div style={styles.tabPanelContainer}>
        {(() => {
          switch (activeTabPanel) {
            case 'Graphics':
              return <Graphics color={color} />
            case 'PhotoUpload':
              return <PhotoUpload />
            case 'AddCaption':
              return <AddCaption isGraphics={isGraphics} />
            case 'Edit':
              if (
                selectedImage &&
                (selectedImage?.type === 'text' ||
                  selectedImage?.type === 'url')
              ) {
                return <Photo img={selectedImage} />
              } else if (selectedImage?.type === 'masked') {
                return <MaskedPhoto img={selectedImage} />
              } else if (selectedImage?.type === 'caption') {
                return <Caption img={selectedImage} isGraphics={isGraphics} />
              } else {
                return (
                  <p style={{textAlign: 'center'}}>
                    {t('Adj hozzá grafikákat és szövegeket!')}
                  </p>
                )
              }
            case 'PixaBay':
              return <PixaBay />
            default:
              return (
                <p style={{textAlign: 'center'}}>
                  {t('Adj hozzá grafikákat és szövegeket!')}
                </p>
              )
          }
        })()}
      </div>
    </div>
  )
}
